export default __webpack_public_path__ + "static/media/fanSkillContestmage.7fee0449.jpg";